import { render, staticRenderFns } from "./DragDropFileWithIcon.vue?vue&type=template&id=09ac8570&scoped=true"
import script from "./DragDropFileWithIcon.vue?vue&type=script&lang=js"
export * from "./DragDropFileWithIcon.vue?vue&type=script&lang=js"
import style0 from "./DragDropFileWithIcon.vue?vue&type=style&index=0&id=09ac8570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac8570",
  null
  
)

export default component.exports